module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_data-4a2d716c24911902e2ad7d6a60ce6bae.jpg";